// extracted by mini-css-extract-plugin
export default {"body_wrapper":"body_body_wrapper__cCRfi"};